import {useDialog} from './useDialog';

export const useActivateCardDialog = () => {
  return useDialog<{id: string | undefined}>('activate-card');
};
